import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide5Bridge.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide5Verify(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease }}
        className="mt-4 text-4xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.title}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.35, ease }}
        className="mt-5 text-lg sm:text-2xl text-slate-500 leading-relaxed max-w-3xl"
      >
        {c.body}
      </motion.p>
    </div>
  )
}
